// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_bQv","cls2":"common-cls2_YMN common-cls1_bQv"};